module.exports = __webpack_public_path__ + "media/images/webpage/coupons/howto-get-1512c3b72b284a7451cde4c2300db91a.webp";